export const PUBLIC_FONTS_REQUEST = "API/ENTITIES/PUBLIC_FONTS_REQUEST";
export const PUBLIC_FONTS_REQUEST_FAILURE =
  "API/ENTITIES/PUBLIC_FONTS_REQUEST_FAILURE";
export const PUBLIC_FONTS_REQUEST_SUCCESS =
  "API/ENTITIES/PUBLIC_FONTS_REQUEST_SUCCESS";
export const PUBLIC_FONTS_CSS_PROCESSING =
  "API/ENTITIES/PUBLIC_FONTS_CSS_PROCESSING";
